module.exports = __webpack_public_path__ + "assets/montserrat-bold.7d4374c34587a146f978c69be2013eb1.woff";